import ActionTypes from "../Actions/ActionTypes";

let initialState = {
  getCusModules: [],
  modulesDetail: null,
};

const CusModulesReducer = (state = initialState, action) => {
  // console.log("statee", state);

  switch (action.type) {
    case ActionTypes.GET_CUS_MODULES:
      state = { ...state, getCusModules: action.payload };
      break;

    case ActionTypes.GET_CUS_MODULE_DETAILS:
      state = { ...state, modulesDetail: action.payload };
      break;
    default:
      break;
  }
  return state;
};

export default CusModulesReducer;
